import Vue from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import { Dialog } from "vant";
import { Toast } from "vant";
import context from "@/main";
import { cloneDeep } from "lodash";
import { getLanguage } from "@/lang";
import dayjs from "dayjs";
import encryption from "@/utils/md5.js";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

export const ApiCache = (function() {
  const ApiCacheTimeOut = {
    k1h: 1 * 60 * 1000
  };
  const ApiCacheConfig = {
    "/api/lottery/sysDict/querySystemConfig": {
      cache: true,
      timestamp: 0,
      timeout: ApiCacheTimeOut.k1h,
      response: null
    },
    "/api/v2/cms/queryQrcodesAndServicer": {
      cache: true,
      timestamp: 0,
      timeout: ApiCacheTimeOut.k1h,
      response: null
    },
    "/api/v2/cms/queryAnnounceEssayList": {
      cache: true,
      timestamp: 0,
      timeout: ApiCacheTimeOut.k1h,
      response: null
    },
    "/party/v2/game/quickPlayGames": {
      cache: true,
      timestamp: 0,
      timeout: ApiCacheTimeOut.k1h,
      response: null
    },
    "/party/v2/game/queryTypePlatforms": {
      cache: true,
      timestamp: 0,
      timeout: ApiCacheTimeOut.k1h,
      response: null
    },
    "/party/v2/game/queryPlatformGames": {
      cache: true,
      timestamp: 0,
      timeout: ApiCacheTimeOut.k1h,
      response: null
    },
    "/party/v2/game/queryGameListTypes": {
      cache: true,
      timestamp: 0,
      timeout: ApiCacheTimeOut.k1h,
      response: null
    },
    "/api/v2/home/index": {
      cache: true,
      timestamp: 0,
      timeout: ApiCacheTimeOut.k1h,
      response: null
    }
  };

  function getApiCache(url, key) {
    const { cache } = ApiCacheConfig[url] || {};
    if (!cache) {
      return void 0;
    }
    let config = {};
    try {
      config = JSON.parse(localStorage.getItem(key)) || {};
    } catch (e) {
      config = {};
    }
    const { timestamp = 0, timeout = 0, response = null } = config;
    const curTime = +new Date();
    if (curTime - timestamp > timeout) {
      return void 0;
    } else {
      if (!response.config.noEncrypt) {
        response.data = JSON.parse(
          window.AESDec(response.config.key, response.data.body)
        );
      }
      return new Promise(r => {
        r(response);
      });
    }
  }

  function setApiCache(url = "", key = "", response = null) {
    const { cache, timeout } = ApiCacheConfig[url] || {};
    if (cache) {
      let apiCacheKey = [];
      try {
        apiCacheKey = JSON.parse(localStorage.getItem("api-key-cache")) || [];
      } catch (e) {
        apiCacheKey = [];
      }
      if (!apiCacheKey.includes(key)) {
        apiCacheKey.push(key);
        localStorage.setItem("api-key-cache", JSON.stringify(apiCacheKey));
      }
      localStorage.setItem(
        key,
        JSON.stringify({
          cache,
          timestamp: +new Date(),
          timeout,
          response
        })
      );
    }
  }

  function clearAll() {
    let apiCacheKey = [];
    try {
      apiCacheKey = JSON.parse(localStorage.getItem("api-key-cache")) || [];
    } catch (e) {
      apiCacheKey = [];
    }
    apiCacheKey.forEach(key => {
      localStorage.removeItem(key);
    });
    localStorage.removeItem("api-key-cache");
  }

  return {
    getApiCache,
    setApiCache,
    clearAll
  };
})();
export const noEncryptUrlList = [
  "/lottery/queryLotteryList",
  "/lottery/queryLotteryRecordList"
];
const service = axios.create({
  timeout: 20000
});
Vue.prototype.$axios = axios;
Vue.prototype.$http = service;
Vue.prototype.$https = axios;

service.interceptors.request.use(
  async function(config) {
    if (!sessionStorage.getItem("Authorization")) {
      sessionStorage.setItem("Authorization", "GUEST_TOKEN_3a7b8c9d");
    }
    const rawDeviceId = sessionStorage.getItem("deviceid");
    if (
      rawDeviceId === null ||
      rawDeviceId === undefined ||
      rawDeviceId === "" ||
      rawDeviceId === "null" ||
      rawDeviceId === "undefined"
    ) {
      sessionStorage.setItem("deviceid", "");
    }
    if (!sessionStorage.getItem("refreshToken")) {
      sessionStorage.setItem("refreshToken", "1");
    }
    if (!sessionStorage.getItem("sessionkey")) {
      sessionStorage.setItem("sessionkey", "1");
    }
    if (!sessionStorage.getItem("isSign")) {
      sessionStorage.setItem("isSign", false);
    }
    let Authorization = sessionStorage.getItem("Authorization");
    let deviceid = sessionStorage.getItem("deviceid");
    if (deviceid === "null" || deviceid === "undefined") deviceid = "";
    let sessionkey = sessionStorage.getItem("sessionkey");
    let isSign = sessionStorage.getItem("isSign");
    let tokenForSign = Authorization || "";
    let sign = encryption.encrypt.md5(
      Date.now() + 0 + "##Lottery2017$$" + tokenForSign
    );
    let Lang = localStorage.getItem("Lang") || "zh_CN";
    let timestamp = dayjs().valueOf();
    config.headers.Authorization = `Bearer ${Authorization}`;
    config.headers.Time = timestamp;
    config.headers.timestamp = timestamp;
    config.headers.deviceid = deviceid;
    config.headers.devicename = "h5";
    config.headers.Lang = Lang;
    config.headers.Language = Lang;
    config.headers.sign = sign;
    let dataToSign = "";
    let iv = "";
    let encrypt = async function(plainText) {
      try {
        // 1. Base64 解码密钥
        const keyBytes = Uint8Array.from(atob(sessionkey), c =>
          c.charCodeAt(0)
        );
        // 2. 生成 12 字节随机 IV (GCM 推荐使用 12 字节)
        const ivBytes = crypto.getRandomValues(new Uint8Array(12));
        // 3. 导入密钥
        const cryptoKey = await crypto.subtle.importKey(
          "raw",
          keyBytes,
          { name: "AES-GCM" },
          false,
          ["encrypt"]
        );
        // 4. 将明文转为字节数组
        const encoder = new TextEncoder();
        const plainBytes = encoder.encode(plainText);
        // 5. AES-GCM 加密
        const encryptedBuffer = await crypto.subtle.encrypt(
          {
            name: "AES-GCM",
            iv: ivBytes,
            tagLength: 128 // GCM 标签长度 128 位
          },
          cryptoKey,
          plainBytes
        );
        // 6. 转为 Base64
        const encryptedBytes = new Uint8Array(encryptedBuffer);
        const data = btoa(String.fromCharCode(...encryptedBytes));
        const iv = btoa(String.fromCharCode(...ivBytes));
        return { data, iv };
      } catch (error) {
        console.error("[Encrypt] 加密失败:", error);
        return null;
      }
    };
    let generateSignature = function(
      method,
      uri,
      encryptedBody,
      timestamp,
      sessionKeyBase64
    ) {
      // 1. 构造待签名字符串 (必须与后端 toVerify 拼接逻辑完全一致)
      const toVerify = method.toUpperCase() + uri + encryptedBody + timestamp;
      // 2. 将 Base64 的 SessionKey 转为 WordArray
      const key = CryptoJS.enc.Base64.parse(sessionKeyBase64);
      // 3. 执行 HMAC-SHA256 签名
      const hmac = CryptoJS.HmacSHA256(toVerify, key);
      // 4. 将结果转为 Base64 字符串
      return CryptoJS.enc.Base64.stringify(hmac);
    };

    const isNoEncryptUrl = noEncryptUrlList.some(url =>
      config.url.includes(url)
    );
    if (isNoEncryptUrl) {
      config.headers["X-Security-Action"] = false;
      return config;
    } else {
      if (isSign == "false") {
        config.headers["X-Security-Action"] = false;
        return config;
      }
      let method = config.method.toUpperCase();
      let uri = config.url.replace("/api", "");
      config.headers["X-Security-Action"] = true;
      config.headers["Content-Type"] = "application/json;charset=UTF-8";

      if (method === "GET" || method === "DELETE") {
        const urlParts = uri.split("?");
        uri = urlParts[0];
        const urlParams = {};
        if (urlParts[1]) {
          const urlSearchParams = new URLSearchParams(urlParts[1]);
          urlSearchParams.forEach((value, key) => {
            urlParams[key] = value;
          });
        }

        const params = { ...urlParams, ...(config.params || {}) };
        const sortedKeys = Object.keys(params).sort();
        dataToSign = sortedKeys.map(key => `${key}=${params[key]}`).join("&");
      } else {
        const jsonStr = JSON.stringify(config.data);
        const encrypted = await encrypt(jsonStr);
        if (encrypted) {
          config.transformRequest = [
            data => {
              if (typeof data === "string") {
                return data;
              }
              return JSON.stringify(data);
            }
          ];
          config.data = encrypted.data; // 替换为密文（纯字符串）
          iv = encrypted.iv;
          dataToSign = encrypted.data;
        }
      }
      // 计算签名
      const signature = generateSignature(
        config.method.toUpperCase(),
        uri,
        dataToSign,
        timestamp,
        sessionkey
      );

      // // 设置安全请求头
      config.headers["X-Signature"] = signature;
      config.headers["X-Timestamp"] = timestamp;
      if (iv) {
        config.headers["X-Iv"] = iv;
      }
    }
    return config;
  },
  function(error) {
    //请求错误时做些事
    return Promise.reject(error);
  }
);
async function refreshTokenRequest() {
  try {
    // 创建一个新的axios实例，避免触发拦截器
    const refreshService = axios.create({
      baseURL: "https://789test.biyingbaowang.co/api",
      timeout: 1000 * 10
    });
    let refreshToken = sessionStorage.getItem("refreshToken");
    let deviceid = sessionStorage.getItem("deviceid");
    const time = dayjs().valueOf();
    // 刷新token时使用refreshToken来计算sign
    const sign = encryption.encrypt.md5(
      time + "##Lottery2017$$" + refreshToken
    );

    const response = await refreshService.post(
      "/user/auth/refresh",
      {}, // 请求体为空
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "X-Refresh-Token": refreshToken, // refreshToken - 核心字段，必须
          deviceId: deviceid, // 设备ID - 用于设备管理
          sign: sign, // 签名 - 用于验证请求合法性
          timestamp: time, // 时间戳 - 用于防止重放攻击
          Client: "H5(V1.0.0)"
        }
      }
    );

    if (response.data && response.data.code === 200) {
      sessionStorage.setItem("refreshToken", response.data.data.refreshToken);
      // 更新store中的token和deviceId（如果返回了新的deviceId）
      sessionStorage.setItem("Authorization", response.data.data.accessToken);
    } else {
      throw new Error("Token refresh failed");
    }
  } catch (error) {
    // 如果是401错误，说明refresh token也过期了，需要清除用户信息并跳转登录
    if (error.response.status === 401) {
      // router.replace({
      //   path: "/",
      //   query: {
      //     redirect: router.currentRoute.value?.fullPath,
      //   },
      // });
      // 跳转后弹出登录框
    }
    throw error;
  }
}
var decrypt = async function(base64Data, base64Iv) {
  let sessionkey = sessionStorage.getItem("sessionkey");
  try {
    // 1. Base64 解码
    const keyBytes = Uint8Array.from(atob(sessionkey), c => c.charCodeAt(0));
    const ivBytes = Uint8Array.from(atob(base64Iv), c => c.charCodeAt(0));
    const encryptedBytes = Uint8Array.from(atob(base64Data), c =>
      c.charCodeAt(0)
    );

    // 2. 导入密钥
    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    // 3. AES-GCM 解密
    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: ivBytes,
        tagLength: 128 // GCM 标签长度 128 位
      },
      cryptoKey,
      encryptedBytes
    );

    // 4. 转为字符串
    const decoder = new TextDecoder("utf-8");
    const plainText = decoder.decode(decryptedBuffer);

    return plainText;
  } catch (error) {
    console.error("[Decrypt] 解密失败:", error);
    return null;
  }
};
//添加响应拦截器
service.interceptors.response.use(
  async function(res) {
    let response = await res;
    // // 如果返回结构包含 iv，说明是加密报文
    if (res.data && res.data.iv) {
      try {
        const decryptedStr = await decrypt(res.data.data, res.data.iv);
        if (decryptedStr) {
          // 解密成功，替换 response.data 为解密后的原始业务对象
          response.data = JSON.parse(decryptedStr);
        }
      } catch (e) {
        console.error("解密失败", e);
        return Promise.reject(new Error("数据包校验失败"));
      }
    }

    if (response.config.loading) {
      Toast.clear();
    }
    let code = (await response.data.code) || response.code;
    if (code !== 200) {
      let errText = response.data.msg || context.$tex("服务异常");
      if (
        code === 301 ||
        code === 110 ||
        code === 302 ||
        code === 111 ||
        code === 503 ||
        code === 170
      ) {
        // 清空登录缓存
        store.commit("SET_USER_INFO", {});
        localStorage.setItem("user", "");
        if (!response.config.noDialogTip && code !== 256) {
          //256表示异地登录
          Dialog.confirm({
            title: context.$tex("温馨提示"),
            message: context.$tex(errText)
          })
            .then(() => {
              this.$router.push("/login");
            })
            .catch(() => {
              // on cancel
            });
        }
      }
    }
    return response;
  },
  function(error) {
    //请求错误时做些事
    if (error.response.status == 403) {
      // refreshTokenRequest()
    }
    Toast.clear();
    if (error.message.includes("timeout") && error.config.timeoutDialog) {
      Toast(context.$tex("请求超时"));
    }
    return Promise.reject(error);
  }
);
const requestStore = {};

export default function(config) {
  const key = JSON.stringify(config);
  if (!requestStore[key]) {
    requestStore[key] = {
      lastTime: 0,
      promise: null
    };
  }
  const curTime = +new Date();
  if (curTime - requestStore[key].lastTime > 2000) {
    const p = ApiCache.getApiCache(
      config.url,
      JSON.stringify({
        url: config.url,
        data: config.data
      })
    );
    if (p) {
      return p;
    }
    requestStore[key].lastTime = curTime;
    requestStore[key].promise = service(config);
  }
  return requestStore[key].promise;
}
